import Page from "@/components/layout/Page";
import * as Styled from "./styled";

import Button from "@/components/shared-ui/Button";
import Card from "@/components/shared-ui/Card";
import LoadingScreen from "@/components/shared-ui/LoadingScreen";
import Select from "@/components/shared-ui/Select";
import Toggle from "@/components/shared-ui/Toggle";
import useApi from "@/contexts/ApiContext";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { CardHeading } from "../AdminDashboard/styled";
import { ButtonWrapper } from "../AdminUserEdit/styled";
import { sortCompanies } from "../admin.utils";

const AdminUsersDownload = () => {
  const api = useApi();
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [excludeSecclUsers, setExcludeSecclUsers] = useState(true);

  const { data: companies } = useQuery({ queryKey: ["get-companies"], queryFn: () =>
    api.admin.company.getAll(),
  });

  useEffect(() => {
    if (companies && companies.length > 0 && !selectedCompanyId) {
      setSelectedCompanyId(sortCompanies(companies)[0].id);
    }
  }, [companies, selectedCompanyId]);

  if (!companies) {
    return <LoadingScreen isAdmin />;
  }

  const companyOptions = sortCompanies(companies);

  const handleDownload = async () => {
    const company = companies.find(
      (candidate) => candidate.companyKey === selectedCompanyId,
    );
    if (!company) return;
    let url: string | undefined;
    try {
      const res = await api.admin.user.downloadAllByCompany(
        selectedCompanyId,
        excludeSecclUsers,
      );
      url = URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      const safeName = company.companyName.replace(/[<>:"/\\|?*]/g, "_");
      const date = new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" }).replace(/\//g, "-");
      a.download = `${safeName} users ${date}.csv`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (e) {
      console.error("Failed to download user list", e);
    } finally {
      if (url) URL.revokeObjectURL(url);
    }
  };

  return (
    <Page
      title="Download users"
      isAdmin
      customBreadcrumb={{ path: "/admin/users", label: "Back to users" }}
    >
      <Card>
        <CardHeading>Download user list</CardHeading>
        <p>
          This form can be used to download a CSV file of all the users for a
          given company.
        </p>
        <Styled.Form>
          <Select
            id="company"
            name="company"
            label="Company"
            value={selectedCompanyId}
            onChange={(e) => setSelectedCompanyId(e.target.value)}
            options={companyOptions}
          />
          <Toggle
            label="Exclude Seccl users"
            isChecked={excludeSecclUsers}
            handleToggle={() => setExcludeSecclUsers((prev) => !prev)}
          />
          <ButtonWrapper>
            <Button
              type="button"
              label="Download as CSV"
              disabled={!selectedCompanyId}
              onClick={handleDownload}
            />
          </ButtonWrapper>
        </Styled.Form>
      </Card>
    </Page>
  );
};

export default AdminUsersDownload;
